import React from 'react';
import { View } from 'react-native';

function EventFromIcs({ route }: any): React.ReactElement {
  return <View />;
}

export default EventFromIcs;
